import React, { useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
} from "@mui/material";
import Layout from "../components/layout/GSTlayout";
import { Bar, Pie, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement, 
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement, 
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TaxReportsPage = () => {
  
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedQuarter, setSelectedQuarter] = useState("Q1");


  const taxData = {
    yearlyTaxCollection: {
      labels: ["2020", "2021", "2022", "2023", "2024"],
      datasets: [
        {
          label: "Total Tax Collection (₹ Lakhs)",
          data: [450, 620, 850, 1100, 1350],
          backgroundColor: "rgba(75, 192, 192, 0.6)",
        },
      ],
    },
    taxBreakdown: {
      labels: ["CGST", "SGST", "IGST", "Cess"],
      datasets: [
        {
          data: [35, 35, 25, 5],
          backgroundColor: [
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
            "rgba(255, 206, 86, 0.6)",
            "rgba(75, 192, 192, 0.6)",
          ],
        },
      ],
    },
    monthlyTaxTrend: {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      datasets: [
        {
          label: "Monthly Tax Collection (₹ Lakhs)",
          data: [95, 110, 130, 120, 140, 160],
          borderColor: "rgb(75, 192, 192)",
          tension: 0.1,
        },
      ],
    },
  };

  // Chart options
  const barOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Yearly Tax Collection" },
    },
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: { position: "right" },
      title: { display: true, text: "Tax Type Breakdown" },
    },
  };

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Monthly Tax Collection Trend" },
    },
  };

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          GST Tax Reports
        </Typography>

        {/* Filtering Controls */}
        <Box sx={{ display: "flex", mb: 3, gap: 2 }}>
          <FormControl variant="outlined" sx={{ minWidth: 120 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              label="Year"
            >
              {[2020, 2021, 2022, 2023, 2024].map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={{ minWidth: 120 }}>
            <InputLabel>Quarter</InputLabel>
            <Select
              value={selectedQuarter}
              onChange={(e) => setSelectedQuarter(e.target.value)}
              label="Quarter"
            >
              {["Q1", "Q2", "Q3", "Q4"].map((quarter) => (
                <MenuItem key={quarter} value={quarter}>
                  {quarter}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Charts Grid */}
        <Grid container spacing={3}>
          {/* Yearly Tax Collection Bar Chart */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 2, height: "100%" }}>
              <Bar data={taxData.yearlyTaxCollection} options={barOptions} />
            </Paper>
          </Grid>

          {/* Tax Type Breakdown Pie Chart */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 2, height: "100%" }}>
              <Pie data={taxData.taxBreakdown} options={pieOptions} />
            </Paper>
          </Grid>

          {/* Monthly Tax Trend Line Chart */}
          <Grid item xs={12}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Line data={taxData.monthlyTaxTrend} options={lineOptions} />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default TaxReportsPage;
